import { TimesheetPage } from "../../modules/timesheet/timesheet-page"

interface TimesheetProps {
  sidebarOpen?: boolean
}

export default function Timesheet({sidebarOpen }: TimesheetProps) {
  return <TimesheetPage sidebarOpen={sidebarOpen}/>
}
